import { useQuery } from '@tanstack/react-query'
import useAuthStore from '../../../stores/useAuthStore/useAuthStore'
import { useAxiosInstance } from '../useAxiosInstance'
import {
    EnergySourcesAndContractsResponse,
    GetEnergySourcesAndContractsRequestParams,
} from '../types'

export const useDataManagementApi = () => {
    const accessToken = useAuthStore((state) => state.accessToken)
    const axiosInstance = useAxiosInstance(accessToken)
    const customerId =
        useAuthStore((state) => state.customer?.customerId.toString()) ?? ''

    const useEnergyContractsQuery = (
        params: Omit<
            GetEnergySourcesAndContractsRequestParams,
            'customerId'
        > = {},
        options: useEnergyContractsQueryOpts = { enabled: true }
    ) => {
        return useQuery<EnergySourcesAndContractsResponse>({
            queryKey: ['energy-contracts', customerId, params],
            queryFn: async () => {
                try {
                    const response =
                        await axiosInstance.get<EnergySourcesAndContractsResponse>(
                            `/api/v1/customers/${customerId}/energy-contracts`,
                            {
                                params,
                            }
                        )
                    options.onSuccess?.(response.data)
                    return response.data
                } catch (error) {
                    options.onError?.()
                    throw error
                }
            },
            enabled: options.enabled && !!accessToken && !!customerId,
        })
    }

    return {
        useEnergyContractsQuery,
    }
}

type useEnergyContractsQueryOpts = {
    enabled?: boolean
    onSuccess?: (data: EnergySourcesAndContractsResponse) => void
    onError?: () => void
}
